import { Component, ReactNode } from "react";

/**
 * Section-level error boundary. One bad fetch can't take the whole
 * page down. The `label` makes the captured error grep-able in console.
 */
interface Props {
  label: string;
  children: ReactNode;
}
interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: { componentStack?: string }): void {
    // eslint-disable-next-line no-console
    console.error(`[Owl/${this.props.label}] render error:`, error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="card border-red-200 p-4">
          <p className="text-sm font-semibold text-red-900">
            This part of Owl couldn't render.
          </p>
          <p className="mt-1 text-xs text-slate-500">
            Refresh the page to try again – the rest still works.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}
